import React from 'react';
import { ArrowRight, Cable, FolderGit2, ShieldCheck } from 'lucide-react';
import type { ProjectSummary } from '../api.js';
import McpAccessStatus from '../components/McpAccessStatus.js';
import McpCreditWallet from '../components/McpCreditWallet.js';
import GrokBotConnect, { SUBSCRIBER_MCP_URL } from '../components/GrokBotConnect.js';

type McpConnectPageProps = { projects?: ProjectSummary[]; onNavigate?: (page: string) => void };

const row: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
  gap: 16,
  marginBottom: 16,
  alignItems: 'stretch',
};
const cardPad: React.CSSProperties = { padding: 18, margin: 0 };

export function McpConnectPage({ projects = [], onNavigate }: McpConnectPageProps): React.ReactElement {
  const projectLabel = projects.length === 0 ? 'No connected repositories yet'
    : `${projects.length} connected ${projects.length === 1 ? 'repository' : 'repositories'}`;
  return <div className="mcp-connect-page">
    <div className="page-title-row" style={{ gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
      <div>
        <div className="section-label" style={{ color: 'var(--accent)', marginBottom: 4 }}>OCNEXUS MCP</div>
        <h2 className="page-title" style={{ fontSize: 'clamp(20px, 2.4vw, 26px)', marginBottom: 4 }}>Use Forge from Grok.</h2>
        <p className="page-subtitle" style={{ maxWidth: 680, margin: 0 }}>Request Forge reviews and follow findings, run status, and credit usage from Grok.</p>
      </div>
      <div className="mcp-connect-status"><Cable size={15} /> Connection guide</div>
    </div>

    <div style={row}>
      <McpAccessStatus />
      <GrokBotConnect />
    </div>

    <div style={row}>
      <section className="card" aria-labelledby="mcp-endpoint-heading" style={cardPad}>
        <div className="section-label" id="mcp-endpoint-heading">Using another MCP app?</div>
        <p style={{ margin: '6px 0', overflowWrap: 'anywhere' }}>Server URL: <code>{SUBSCRIBER_MCP_URL}</code></p>
        <p style={{ margin: 0 }}>Add it to your app, sign in through your browser with your OCNexus account, and allow access.</p>
      </section>
      <aside className="card" aria-labelledby="mcp-workspace-heading" style={cardPad}>
        <div className="mcp-card-heading"><h3 id="mcp-workspace-heading" style={{ margin: 0 }}>Your workspace</h3><ShieldCheck size={19} /></div>
        <p style={{ margin: '8px 0' }}><FolderGit2 size={14} /> {projectLabel}</p>
        <p style={{ margin: '0 0 12px' }}>Forge reviews only repositories authorized for your workspace. Each run reserves credits before work starts; top up here when you need more.</p>
        <button type="button" className="btn" onClick={(): void => onNavigate?.('subscriber-chat:mcp')}>View work in OCNexus <ArrowRight size={14} /></button>
      </aside>
    </div>

    <McpCreditWallet />
  </div>;
}
